export { cache } from '../../../../server/use-cache/use-cache-wrapper'
